import { createContext } from 'react';

export const BranchesContext = createContext(null);